import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeField as authChangeField, initializeForm, login } from '../../modules/auth/authSlice';
// import { changeField } from '../modules/index';
import AuthForm from './AuthForm';
import { useNavigate } from 'react-router-dom';
import { check } from '../../modules/auth/userSlice';

const LoginForm = () => {
    const dispatch = useDispatch();
    const { form, auth, authError, user } = useSelector(({ auth, user }) => ({
        form: auth.login,
        auth: auth.auth,
        authError: auth.authError,
        user: user.user,
    }));
    const [error, setError] = useState(null);

    // 인풋 변경 이벤트 핸들러
    const onChange = (e) => {
        const { value, name } = e.target;
        // dispatch 구현
        dispatch(
            authChangeField({
                form: 'login',
                key: name,
                value,
            }),
        );
    };

    // 폼 등록 이벤트 핸들러
    const onSubmit = async (e) => {
        e.preventDefault();
        // 구현 예정
        const { username, password } = form;
        dispatch(login({ username, password }));
    };

    // 컴포넌트가 처음 렌더링될 때 폼을 초기화함
    useEffect(() => {
        dispatch(initializeForm({ form: 'login' }));

    }, [dispatch]);

    useEffect(() => {
        if (authError) {
            setError('로그인 실패');
            return;
        }
        if (auth) {
            dispatch(check());
        }
    }, [auth, authError, dispatch]);

    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            navigate('/');
            /*
                로그인 상태 유지를 위해 브라우저에 있는 localStorage를 사용.
                저장된 내용은 src/index.js에서 불러와 사용. const user = localStorage.getItem('user');
            */
            try {
                localStorage.setItem('user', JSON.stringify(user));
            } catch (e) {
                console.error('localStorage is not working');
            }
        }
    }, [user, navigate]);

    return <AuthForm type="login" form={form} onChange={onChange} onSubmit={onSubmit} error={error} />;
};

export default LoginForm;
